import httpClient from 'shared/lib/httpClient';

export const resetPassword = async (formData) => {
  const response = await httpClient.post('/reset-password', formData);
  return response?.data;
};
